import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

export const vendorCommissionBandSerializeMap: SerializeMap<VendorCommissionBand> =
  {
    id: "id",
    businessId: "business_id",
    commissionType: "commission_type",
    commissionValue: "commission_value",
    deploymentId: "deployment_id",
    saleSubTypeId: "sale_sub_type_id",
    saleType: "sale_type",
    speciesId: "species_id",
  };

export const serializeVendorCommissionBand =
  buildSerializer<VendorCommissionBand>(
    vendorCommissionBandSerializeMap,
    "vendor commission band",
  );

export const deserializeVendorCommissionBand =
  buildDeserializer<VendorCommissionBand>(
    vendorCommissionBandSerializeMap,
    "vendor commission band",
  );
